export function RoundToPlace(number, places) {
  return Math.round(number * Math.pow(10, places)) / Math.pow(10, places)
}
